import { AlertTriangle, Clock, TrendingDown, MessageSquareOff, GitBranch, Wallet } from "lucide-react";

const pains = [
  { icon: MessageSquareOff, title: "Leads perdidos por mala atención", desc: "Conversaciones que mueren porque nadie responde a tiempo." },
  { icon: Clock, title: "Equipos que tardan horas en responder", desc: "El 78% de los clientes compra a quien responde primero." },
  { icon: TrendingDown, title: "Tráfico pagado desperdiciado", desc: "Inviertes en Ads pero no tienes sistema para convertir." },
  { icon: GitBranch, title: "Procesos manuales sin escalar", desc: "Tu operación depende de personas, no de sistemas." },
  { icon: AlertTriangle, title: "Cero seguimiento comercial", desc: "Las oportunidades se enfrían y nunca regresan." },
  { icon: Wallet, title: "Quemas presupuesto cada mes", desc: "Sin automatización, cada lead cuesta el doble." },
];

export default function Problem() {
  return (
    <section id="problem" data-testid="problem-section" className="relative py-24 sm:py-32">
      <div className="container-x relative">
        <div className="max-w-3xl reveal">
          <div className="eyebrow mb-5">El problema real</div>
          <h2 className="font-display font-extrabold text-white text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[1.04]">
            Tu negocio no pierde por <span className="text-gradient">falta de tráfico</span>.
            Pierde por <span className="text-gradient">falta de sistema</span>.
          </h2>
          <p className="mt-6 text-zinc-400 text-lg max-w-2xl">
            La mayoría de empresas medianas y grandes no tienen un problema de marketing.
            Tienen un problema de operación: leads que se enfrían, conversaciones sin respuesta y publicidad sin un sistema detrás.
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {pains.map(({ icon: Icon, title, desc }, i) => (
            <div key={title} className="reveal grad-border p-7 card-lift" style={{ transitionDelay: `${i * 60}ms` }}>
              <div className="w-11 h-11 rounded-xl glass grid place-items-center text-[#ff8a00] mb-5">
                <Icon className="w-5 h-5" />
              </div>
              <h3 className="font-display font-semibold text-white text-lg leading-snug">{title}</h3>
              <p className="mt-2 text-zinc-400 text-sm leading-relaxed">{desc}</p>
            </div>
          ))}
        </div>

        {/* Stat strip */}
        <div className="mt-14 grid sm:grid-cols-3 gap-4 reveal">
          {[
            { v: "78%", l: "compra a quien responde primero" },
            { v: "5x", l: "más conversión con respuesta < 5 min" },
            { v: "40%", l: "del tráfico pagado se pierde sin automatización" },
          ].map((s) => (
            <div key={s.l} className="glass rounded-2xl p-6 flex items-baseline gap-4">
              <div className="font-display font-extrabold text-3xl sm:text-4xl text-gradient">{s.v}</div>
              <div className="text-zinc-400 text-sm">{s.l}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
